import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { PlantAdminsService } from "../../services/technical-letters/plant-admins.service";
import { MatPaginator } from "@angular/material/paginator";

@Component({
    selector: "app-deleted-letter-logs",
    templateUrl: "./deleted-letter-logs.component.html",
    styleUrls: ["./deleted-letter-logs.component.css"],
    standalone: false
})
export class DeletedLetterLogsComponent implements OnInit {
  displayedColumns: string[] = [
    "rowUpdatedDate",
    "rowUpdateBy",
    "letterNumber",
    "letterTitle",
    "letterStatus",
    "letterCategory",
    "letterIssueDate",
    "letterUrl",
    "letterRecurringFlag",
  ];
  dataSource = new MatTableDataSource<any>([]);
  loading = true;
  error: string | null = null;

  constructor(private letterService: PlantAdminsService) {}
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit(): void {
    this.letterService.getDeletedLetterLogs().subscribe({
      next: (logs: any[]) => {
        this.dataSource.data = logs;
        this.loading = false;
      },
      error: (err) => {
        this.error = "Failed to load deleted letter logs";
        console.error(err);
        this.loading = false;
      },
    });
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
}
